import logFactory from 'c9-js-log-client';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ResourceContext from './contexts/ResourceContext';
import TopContext from './contexts/TopContext';
import { setLogger } from './lib/logger';
import './index.scss';

let context = window || {};

context.ContactUsChart = (function () {
    function bootstrapApplication(config, bootstrapElement) {
        const logger = logFactory(
            config.getEndpointConfig().logger,
            config.appName,
            config.logLevel ?? config.getSiteConfig().logLevel
        );
        setLogger(logger);

        logger.debug(`Starting up application ${logger.appName}`);

        ReactDOM.render(
            <TopContext.Provider
                value={{
                    appName: config.appName,
                    endpointConfig: config.getEndpointConfig(),
                    siteConfig: config.getSiteConfig(),
                }}
            >
                <ResourceContext>
                    <App dateTime={config.dateTime ?? new Date()} />
                </ResourceContext>
            </TopContext.Provider>,
            bootstrapElement
        );
    }
    return bootstrapApplication;
})();
